/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.
import { Route as rootRouteImport } from './routes/__root.js';
import { Route as SucheRouteImport } from './routes/suche.js';
import { Route as LoginRouteImport } from './routes/login.js';
import { Route as IndexRouteImport } from './routes/index.js';
import { Route as SearchPsychotherapistsInChar123CityslugChar125RouteImport } from './routes/search/psychotherapists-in-{-$cityslug}.js';
import { Route as DevDesignsystemRouteImport } from './routes/dev/designsystem.js';
import { Route as TherapistImportedRouteRouteImport } from './routes/therapist/imported/route.js';
import { Route as PsychotherapieUserIdCustomerIdRouteImport } from './routes/psychotherapie/$userId.$customerId.js';
import { Route as ProfileCustomerIdUserIdRouteImport } from './routes/profile/$customerId.$userId.js';
import { Route as ProfileCustomerIdUserIdSplatRouteImport } from './routes/profile/$customerId.$userId.$.js';
import { Route as ClientInvoiceDownloadTokenRouteImport } from './routes/client/invoice/download.$token.js';
import { Route as AppointmentWidgetUserIdCustomerIdRouteImport } from './routes/appointment/widget/$userId.$customerId.js';
const SucheRoute = SucheRouteImport.update({
    id: '/suche',
    path: '/suche',
    getParentRoute: () => rootRouteImport,
});
const LoginRoute = LoginRouteImport.update({
    id: '/login',
    path: '/login',
    getParentRoute: () => rootRouteImport,
});
const IndexRoute = IndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => rootRouteImport,
});
const SearchPsychotherapistsInChar123CityslugChar125Route = SearchPsychotherapistsInChar123CityslugChar125RouteImport.update({
    id: '/search/psychotherapists-in-{-$cityslug}',
    path: '/search/psychotherapists-in-{-$cityslug}',
    getParentRoute: () => rootRouteImport,
});
const DevDesignsystemRoute = DevDesignsystemRouteImport.update({
    id: '/dev/designsystem',
    path: '/dev/designsystem',
    getParentRoute: () => rootRouteImport,
});
const TherapistImportedRouteRoute = TherapistImportedRouteRouteImport.update({
    id: '/therapist/imported',
    path: '/therapist/imported',
    getParentRoute: () => rootRouteImport,
});
const PsychotherapieUserIdCustomerIdRoute = PsychotherapieUserIdCustomerIdRouteImport.update({
    id: '/psychotherapie/$userId/$customerId',
    path: '/psychotherapie/$userId/$customerId',
    getParentRoute: () => rootRouteImport,
});
const ProfileCustomerIdUserIdRoute = ProfileCustomerIdUserIdRouteImport.update({
    id: '/profile/$customerId/$userId',
    path: '/profile/$customerId/$userId',
    getParentRoute: () => rootRouteImport,
});
const ProfileCustomerIdUserIdSplatRoute = ProfileCustomerIdUserIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => ProfileCustomerIdUserIdRoute,
});
const ClientInvoiceDownloadTokenRoute = ClientInvoiceDownloadTokenRouteImport.update({
    id: '/client/invoice/download/$token',
    path: '/client/invoice/download/$token',
    getParentRoute: () => rootRouteImport,
});
const AppointmentWidgetUserIdCustomerIdRoute = AppointmentWidgetUserIdCustomerIdRouteImport.update({
    id: '/appointment/widget/$userId/$customerId',
    path: '/appointment/widget/$userId/$customerId',
    getParentRoute: () => rootRouteImport,
});
const ProfileCustomerIdUserIdRouteChildren = {
    ProfileCustomerIdUserIdSplatRoute: ProfileCustomerIdUserIdSplatRoute,
};
const ProfileCustomerIdUserIdRouteWithChildren = ProfileCustomerIdUserIdRoute._addFileChildren(ProfileCustomerIdUserIdRouteChildren);
const rootRouteChildren = {
    IndexRoute: IndexRoute,
    LoginRoute: LoginRoute,
    SucheRoute: SucheRoute,
    TherapistImportedRouteRoute: TherapistImportedRouteRoute,
    DevDesignsystemRoute: DevDesignsystemRoute,
    SearchPsychotherapistsInChar123CityslugChar125Route: SearchPsychotherapistsInChar123CityslugChar125Route,
    ProfileCustomerIdUserIdRoute: ProfileCustomerIdUserIdRouteWithChildren,
    PsychotherapieUserIdCustomerIdRoute: PsychotherapieUserIdCustomerIdRoute,
    AppointmentWidgetUserIdCustomerIdRoute: AppointmentWidgetUserIdCustomerIdRoute,
    ClientInvoiceDownloadTokenRoute: ClientInvoiceDownloadTokenRoute,
};
export const routeTree = rootRouteImport
    ._addFileChildren(rootRouteChildren)
    ._addFileTypes();
//# sourceMappingURL=routeTree.gen.js.map